import React from "react";
import {Card, Input, List, Skeleton} from "antd";
import {ShopOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {HeaderText} from "../profileStyles";

export const CustomerInfoCard = ({userProfileInfo}) => {
    const {t} = useTranslation(["profilePage"]);
    console.log("userProfileInfo", userProfileInfo);
    const companyInfo = [];

    // Firma bilgileri
    if (userProfileInfo?.companyInfos?.length > 0) {
        const companies = userProfileInfo.companyInfos
            .map(company => company.companyName)
            .join(", ");
        companyInfo.push({
            title: t("fields.companyName", {ns: "common"}),
            value: companies || t("profilePage.notCompanyAssigned", {ns: "profilePage"})
        });
    }

    // Alt firma bilgileri
    if (userProfileInfo?.subcompanyInfos?.length > 0) {
        const subCompanies = userProfileInfo.subcompanyInfos
            .map(subCompany => subCompany.name)
            .join(", ");
        companyInfo.push({
            title: t("fields.subcompanyName", {ns: "common"}),
            value: subCompanies || t("profilePage.notCompanyAssigned", {ns: "profilePage"})
        });
    }

    // İl/İlçe bilgileri (subcompanyInfos'tan gelecek)
    const subCompany = userProfileInfo?.subcompanyInfos?.[0];
    const cityCounty =
        subCompany?.city && subCompany?.county
            ? `${subCompany.city} / ${subCompany.county}`
            : subCompany?.city || subCompany?.county || "Belirlenmemiş";

    companyInfo.push({
        title: "İl/İlçe",
        value: cityCounty
    });

    // Adres bilgisi
    companyInfo.push({
        title: "Adres",
        value: subCompany?.address || "Belirlenmemiş"
    });

    // Email bilgisi
    companyInfo.push({
        title: "E-mail",
        value: subCompany?.authorizedEmail || "Belirlenmemiş"
    });

    // Telefon bilgisi
    companyInfo.push({
        title: "Telefon",
        value: userProfileInfo.phone || "Belirlenmemiş"
    });

    return (
        <Card
            title={
                <h4>
                    <ShopOutlined />
                    <HeaderText>İşletme Bilgileri</HeaderText>
                </h4>
            }
        >
            <List
                dataSource={companyInfo}
                renderItem={row => (
                    <List.Item style={styles.listItem}>
                        <Skeleton loading={false} active>
                            <List.Item.Meta description={row.title} style={styles.listItemMeta} />
                            {/* <div
                                data-testid="companyInfo"
                                data-testvalue={row.title}
                                style={styles.listItemValue}
                            >
                                {row.value}
                            </div> */}
                            <Input value={row.value} disabled className="user-info-input" />
                        </Skeleton>
                    </List.Item>
                )}
                style={styles.list}
            />
        </Card>
    );
};

const styles = {
    list: {
        backgroundColor: "#fff",
        borderRadius: "4px"
    },
    listItem: {
        padding: "12px 0",
        borderBottom: "1px solid #f0f0f0"
    },
    listItemMeta: {
        padding: "10px 20px",
        minWidth: "150px",
        fontWeight: "500",
        color: "#666"
    },
    listItemValue: {
        padding: "10px 20px",
        flex: 1,
        fontWeight: "400",
        color: "#333"
    }
};
